import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ConfigurationStore } from "stores";

import { carbandoTheme, getCustomerTheme } from "themes";

interface ITheme {
  theme?: string;
}

const Theme: React.FC<ITheme> = ({ theme, children }): JSX.Element => {
  const [currentTheme, setTheme] = useState(carbandoTheme);
  const configuration = React.useContext(ConfigurationStore);

  const showroomId = configuration.showroomId || process.env.REACT_APP_SHOP_ID;

  useEffect(() => {
    const loadCustomerTheme = async () => {
      const customerTheme = await getCustomerTheme(showroomId || "");
      setTheme(customerTheme);
    };
    loadCustomerTheme();
  }, [showroomId]);

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default Theme;
